"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarDataLayer = exports.WishlistEvents = exports.CartEvents = void 0;
var CartEvents;
(function (CartEvents) {
    CartEvents["ADD"] = "add_to_cart";
    CartEvents["REMOVE"] = "remove_from_cart";
})(CartEvents = exports.CartEvents || (exports.CartEvents = {}));
var WishlistEvents;
(function (WishlistEvents) {
    WishlistEvents["ADD"] = "add_to_wishlist";
    WishlistEvents["REMOVE"] = "remove_from_wishlist";
})(WishlistEvents = exports.WishlistEvents || (exports.WishlistEvents = {}));
class SolarDataLayer {
    /**
     * Create new dataLayer element when there is none
     */
    constructor() {
        this.dataLayer = window.dataLayer || [];
    }
    /**
     *
     * @param config
     * @param currency
     */
    static init(config, currency) {
        if (SolarDataLayer.instance) {
            return SolarDataLayer.instance;
        }
        if (config) {
            SolarDataLayer.config = Object.assign(Object.assign({}, SolarDataLayer.config), config);
        }
        if (currency) {
            SolarDataLayer.currency = currency;
        }
        SolarDataLayer.instance = new SolarDataLayer();
        return SolarDataLayer.instance;
    }
    /**
     *
     * @param value
     */
    static dataLayerValue(value) {
        return value || '';
    }
    /**
     * Reset dataLayer
     */
    static resetDataLayer() {
        window.dataLayer.push({ 'ecommerce': null });
    }
    /**
     *
     * @param value
     */
    static formatPrice(value) {
        const price = typeof value === 'string' ? parseFloat(value) : value;
        const multiplier = Math.pow(10, 2);
        return (Math.round(price * multiplier) / multiplier);
    }
    /**
     *
     * @param categories
     * @param position
     */
    static resolveCategory(categories, position) {
        return categories[position] || '';
    }
    /**
     *
     * @param oldPrice
     * @param price
     */
    static getSalePrice(oldPrice, price) {
        return oldPrice !== price ? oldPrice - price : '';
    }
    /**
     *
     * @param product
     */
    static defaultProductInformation(product) {
        const config = SolarDataLayer.config;
        const productData = {
            'item_name': SolarDataLayer.dataLayerValue(product[config['item_name']]),
            'item_id': SolarDataLayer.dataLayerValue(product[config['item_id']]),
            'item_group_id': SolarDataLayer.dataLayerValue(product[config['item_group_id']]),
            'item_brand': SolarDataLayer.dataLayerValue(product[config['item_brand']]),
            'item_variant': SolarDataLayer.dataLayerValue(product[config['item_variant']]),
            'currency': SolarDataLayer.currency,
            'price': SolarDataLayer.dataLayerValue(SolarDataLayer.formatPrice(product[config['price']])),
            'discount': SolarDataLayer.getSalePrice(SolarDataLayer.formatPrice(product[config['old_price']]), SolarDataLayer.formatPrice(product[config['price']]))
        };
        let categoryData = {};
        for (let i = 0; i < 5; i++) {
            categoryData[`item_category${i > 0 ? i + 1 : ''}`] = SolarDataLayer.resolveCategory(Object.prototype.hasOwnProperty.call(product, config['item_categories']) ? product[config['item_categories']] : [], i);
        }
        return Object.assign(Object.assign({}, productData), categoryData);
    }
    /**
     *
     * @param product
     */
    static quoteProductInformation(product) {
        const config = SolarDataLayer.config;
        const productData = {
            'item_name': SolarDataLayer.dataLayerValue(product[config['item_name']]),
            'item_id': SolarDataLayer.dataLayerValue(product['item_id']),
            'item_group_id': SolarDataLayer.dataLayerValue(product[config['item_group_id']]),
            'item_brand': SolarDataLayer.dataLayerValue(product['extension_attributes'][config['item_brand']]),
            'item_variant': SolarDataLayer.dataLayerValue(product['extension_attributes'][config['item_variant']]),
            'currency': SolarDataLayer.currency,
            'price': SolarDataLayer.dataLayerValue(SolarDataLayer.formatPrice(product['price_incl_tax'])),
            'discount': SolarDataLayer.getSalePrice(SolarDataLayer.formatPrice(product['extension_attributes']['from_price']), SolarDataLayer.formatPrice(product['price_incl_tax'])),
            'quantity': SolarDataLayer.dataLayerValue(product['qty'])
        };
        let categoryData = {};
        //Check if category data is present on the quote item
        const categoryItemsRaw = product['extension_attributes'][config['item_categories']];
        if (categoryItemsRaw) {
            const categoryItems = typeof categoryItemsRaw === 'object' ? categoryItemsRaw : JSON.parse(categoryItemsRaw);
            for (let i = 0; i < 5; i++) {
                categoryData[`item_category${i > 0 ? i + 1 : ''}`] = SolarDataLayer.resolveCategory(categoryItems, i);
            }
        }
        return Object.assign(Object.assign({}, productData), categoryData);
    }
    /**
     *
     * @param products
     * @param listType
     * @param config
     */
    addObservableViewItemsList(products, listType, config = null) {
        if (config) {
            SolarDataLayer.observableConfig = Object.assign(Object.assign({}, SolarDataLayer.observableConfig), config);
        }
        SolarDataLayer.productList = products;
        SolarDataLayer.listType = listType;
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };
        const observer = new IntersectionObserver(SolarDataLayer.addViewItemsListEntries, observerOptions);
        const rootElement = document.getElementById(SolarDataLayer.observableConfig['listSelector'] || 'impressions-observable');
        const itemsPerRow = SolarDataLayer.isMobile ? SolarDataLayer.observableConfig['itemsPerRowMobile'] : SolarDataLayer.observableConfig['itemsPerRowDesktop'];
        if (rootElement) {
            const observeTargets = rootElement.querySelectorAll('[data-index]');
            for (let i = 0; i < observeTargets.length; i++) {
                if (i % itemsPerRow === 0) {
                    observer.observe(observeTargets[i]);
                }
            }
        }
    }
    /**
     *
     * @param entries
     * @param observer
     */
    static addViewItemsListEntries(entries, observer) {
        const productsClone = SolarDataLayer.productList;
        const itemsPerRow = SolarDataLayer.isMobile ? SolarDataLayer.observableConfig['itemsPerRowMobile'] : SolarDataLayer.observableConfig['itemsPerRowDesktop'];
        entries.map(entry => {
            if (entry.isIntersecting && entry.target.hasAttribute('data-index')) {
                const itemIndex = parseInt(entry.target.getAttribute('data-index'));
                SolarDataLayer.init().addViewItemsList(productsClone.slice(itemIndex, itemIndex + itemsPerRow), SolarDataLayer.listType, itemIndex);
                observer.unobserve(entry.target);
            }
        });
    }
    /**
     *
     * @param products
     * @param listType
     * @param index
     */
    addViewItemsList(products, listType, index = 0) {
        if (!window.dataLayer.filter(e => e['event'] === 'view_item_list').length) {
            SolarDataLayer.resetDataLayer();
        }
        let items = [];
        products.forEach((product) => {
            index++;
            const productData = {
                'item_list_id': listType.replace(/ /g, '_').toLowerCase(),
                'item_list_name': listType,
                'index': index,
            };
            items.push(Object.assign({}, productData, SolarDataLayer.defaultProductInformation(product)));
        });
        window.dataLayer.push({
            'event': 'view_item_list',
            'ecommerce': {
                'items': items
            }
        });
    }
    /**
     *
     * @param product
     * @param index
     * @param listType
     */
    addSelectItem(product, index, listType) {
        SolarDataLayer.resetDataLayer();
        let items = [];
        const productData = {
            'item_list_id': listType.replace(/ /g, '_').toLowerCase(),
            'item_list_name': listType,
            'index': index,
        };
        items.push(Object.assign({}, productData, SolarDataLayer.defaultProductInformation(product)));
        window.dataLayer.push({
            'event': 'select_item',
            'ecommerce': {
                'currency': SolarDataLayer.currency,
                'items': items
            }
        });
    }
    /**
     *
     * @param product
     */
    addViewItem(product) {
        SolarDataLayer.resetDataLayer();
        let extraOptions = {};
        if (product['product_type'] === 'bundle' && Object.prototype.hasOwnProperty.call(product, 'bundle_options')) {
            let items = [];
            product['bundle_options'].forEach((bundleProduct) => {
                items.push(SolarDataLayer.defaultProductInformation(bundleProduct));
            });
            extraOptions = {
                productType: 'bundle',
                bundleItems: items
            };
        }
        window.dataLayer.push({
            'event': 'view_item',
            'ecommerce': {
                'currency': SolarDataLayer.currency,
                'items': [Object.assign(Object.assign({}, SolarDataLayer.defaultProductInformation(product)), extraOptions)]
            }
        });
    }
    /**
     * Add or remove items from cart
     *
     * @param product
     * @param event
     * @param qty
     */
    addAddToCart(product, event = CartEvents.ADD, qty = 1) {
        SolarDataLayer.resetDataLayer();
        let items = [];
        const productData = {
            'quantity': qty,
        };
        if (event === CartEvents.ADD) {
            items.push(Object.assign({}, productData, SolarDataLayer.defaultProductInformation(product)));
        }
        else {
            items.push(Object.assign({}, productData, SolarDataLayer.quoteProductInformation(product)));
        }
        window.dataLayer.push({
            'event': event,
            'ecommerce': {
                'currency': SolarDataLayer.currency,
                'items': items
            }
        });
    }
    /**
     *
     * Add or remove items from wishlist
     *
     * @param product
     * @param event
     */
    addAddToWishlist(product, event = WishlistEvents.ADD) {
        SolarDataLayer.resetDataLayer();
        window.dataLayer.push({
            'event': event,
            'ecommerce': {
                'items': SolarDataLayer.defaultProductInformation(product)
            }
        });
    }
    /**
     *
     * @param products
     * @param cartValue
     * @param couponCode
     */
    addViewCart(products, cartValue, couponCode = '') {
        SolarDataLayer.resetDataLayer();
        let items = [];
        products.forEach((product, index) => {
            const productData = {
                'index': index,
                'coupon': couponCode
            };
            items.push(Object.assign({}, productData, SolarDataLayer.quoteProductInformation(product)));
        });
        window.dataLayer.push({
            'event': 'view_cart',
            'ecommerce': {
                'currency': SolarDataLayer.currency,
                'value': SolarDataLayer.formatPrice(cartValue),
                'items': items
            }
        });
    }
    /**
     *
     * @param products
     * @param cartValue
     * @param couponCode
     */
    addBeginCheckout(products, cartValue, couponCode = '') {
        SolarDataLayer.resetDataLayer();
        let items = [];
        products.forEach((product, index) => {
            const productData = {
                'index': index,
                'coupon': couponCode
            };
            items.push(Object.assign({}, productData, SolarDataLayer.quoteProductInformation(product)));
        });
        window.dataLayer.push({
            'event': 'begin_checkout',
            'ecommerce': {
                'currency': SolarDataLayer.currency,
                'value': SolarDataLayer.formatPrice(cartValue),
                'items': items
            }
        });
    }
    /**
     *
     * @param products
     * @param cartValue
     * @param shippingTier
     * @param couponCode
     */
    addAddShippingInfo(products, cartValue, shippingTier = '', couponCode = '') {
        SolarDataLayer.resetDataLayer();
        let items = [];
        products.forEach((product, index) => {
            const productData = {
                'index': index,
                'coupon': couponCode
            };
            items.push(Object.assign({}, productData, SolarDataLayer.quoteProductInformation(product)));
        });
        window.dataLayer.push({
            'event': 'add_shipping_info',
            'ecommerce': {
                'currency': SolarDataLayer.currency,
                'value': SolarDataLayer.formatPrice(cartValue),
                'coupon': couponCode,
                'shipping_tier': shippingTier,
                'items': items
            }
        });
    }
    /**
     *
     * @param products
     * @param cartValue
     * @param paymentType
     * @param couponCode
     */
    addAddPaymentInfo(products, cartValue, paymentType = '', couponCode = '') {
        SolarDataLayer.resetDataLayer();
        let items = [];
        products.forEach((product, index) => {
            const productData = {
                'index': index,
                'coupon': couponCode
            };
            items.push(Object.assign({}, productData, SolarDataLayer.quoteProductInformation(product)));
        });
        window.dataLayer.push({
            'event': 'add_payment_info',
            'ecommerce': {
                'currency': SolarDataLayer.currency,
                'value': SolarDataLayer.formatPrice(cartValue),
                'coupon': couponCode,
                'payment_type': paymentType,
                'items': items
            }
        });
    }
    /**
     *
     * @param products
     * @param transactionId
     * @param affiliation
     * @param cartValue
     * @param tax
     * @param shipping
     * @param couponCode
     */
    addPurchase(products, transactionId, affiliation = '', cartValue, tax, shipping, couponCode = '') {
        SolarDataLayer.resetDataLayer();
        let items = [];
        products.forEach((product, index) => {
            const productData = {
                'index': index,
                'coupon': couponCode,
                'affiliation': affiliation
            };
            items.push(Object.assign({}, productData, SolarDataLayer.quoteProductInformation(product)));
        });
        window.dataLayer.push({
            'event': 'purchase',
            'ecommerce': {
                'transaction_id': transactionId,
                'affiliation': affiliation,
                'value': SolarDataLayer.formatPrice(cartValue),
                'tax': SolarDataLayer.formatPrice(tax),
                'shipping': SolarDataLayer.formatPrice(shipping),
                'currency': SolarDataLayer.currency,
                'coupon': couponCode,
                'items': items
            }
        });
    }
}
exports.SolarDataLayer = SolarDataLayer;
SolarDataLayer.currency = 'EUR';
SolarDataLayer.config = {
    'item_id': 'product_id',
    'item_group_id': 'item_group_id',
    'item_name': 'name',
    'item_variant_id': '',
    'item_brand': 'manufacturer',
    'item_categories': 'category_names',
    'item_variant': '',
    'price': 'final_price_incl_tax',
    'old_price': 'price_incl_tax',
};
/**
 * Product list used to store list items for observable implementation
 *
 * @protected
 */
SolarDataLayer.productList = [];
/**
 * listType used to store the list type for observable implementation
 *
 * @protected
 */
SolarDataLayer.listType = '';
/**
 * Default config for observable item list
 *
 * @protected
 */
SolarDataLayer.observableConfig = {
    'listSelector': 'impressions-observable',
    'itemsPerRowDesktop': 4,
    'itemsPerRowMobile': 2
};
/**
 *
 * @protected
 */
SolarDataLayer.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
